import { InjectionToken } from '@angular/core';
import { FeatureFlagsConfig } from '../models';

/**
 * Configuration for Feature Flags
 */
export const FEATURE_FLAGS_CONFIG = new InjectionToken<FeatureFlagsConfig>('FEATURE_FLAGS_CONFIG');
